export default __webpack_public_path__ + "static/media/head4.adc5172e.svg";